export default {
    companySetting: 'ตั้งค่าบริษัท',
    profile: 'ประวัติ',
    userManagement: 'จัดการผู้ใช้',
    position: 'ตำแหน่ง',
    bureau: 'สำนักงาน',
    nbtc: 'กสทช.',
    headQuarter: 'สำนักงานใหญ่'
}
